module.exports = __webpack_public_path__ + "static/img/lucky_bg.9156c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/lucky_bg.png
// module id = 0ZWm
// module chunks = 0